// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  display: list-item;
  --background: white;
}

:host {
  background: var(--ion-color-primary, #01091a);
}

ion-header ion-toolbar {
  --background: #fff;
}
ion-header ion-toolbar ion-buttons[slot=end] {
  margin-right: var(--boxx-modal-buttons-end-margin-right, 4px);
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/shared-components/lib/image-detail/image-detail.page.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,mBAAA;AACJ;;AAEA;EACE,6CAAA;AACF;;AAEE;EAME,kBAAA;AAJJ;AAAI;EACE,6DAAA;AAEN","sourcesContent":["ion-content {\n    display: list-item;\n    --background: white;\n}\n\n:host {\n  background: var(--ion-color-primary, #01091a);\n}\nion-header {\n  ion-toolbar {\n\n    ion-buttons[slot=\"end\"] {\n      margin-right: var(--boxx-modal-buttons-end-margin-right, 4px);\n    }\n\n    --background: #fff;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
